document.addEventListener(
	"DOMContentLoaded",
	function () {
		const buttons = document.querySelectorAll(
			".wp-block-camara-comercio-blocks-card-hover > button"
		);
		if (buttons?.length) {
			buttons.forEach((btn) => {
				btn.addEventListener("click", function () {
					btn.parentNode.classList.toggle("active");
				});
			});
		}
	},
	false
);
